(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["soundium-qty-discount"] && !Shopify.designMode) return;
  try {
    (function () {
    function qtyInput(box) {
      var scope = box.closest('.shopify-section') || document;
      return scope.querySelector('quantity-selector-component input[name="quantity"]')
          || scope.querySelector('input[name="quantity"]')
          || document.querySelector('input[name="quantity"]');
    }
    function currentQty(box) {
      var i = qtyInput(box), v = i ? parseInt(i.value, 10) : 1;
      return (isNaN(v) || v < 1) ? 1 : v;
    }
    function setQty(box, n) {
      var i = qtyInput(box);
      if (!i) return;
      i.value = n;
      i.dispatchEvent(new Event('input', { bubbles: true }));
      i.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function recompute(box) {
      var base = parseInt(box.dataset.base, 10) || 0;
      var t2q = +box.dataset.t2q, t2p = +box.dataset.t2p, t3q = +box.dataset.t3q, t3p = +box.dataset.t3p;
      var qty = currentQty(box), pct = 0, active = 1;
      if (qty >= t3q) { pct = t3p; active = 3; }
      else if (qty >= t2q) { pct = t2p; active = 2; }
      box.querySelectorAll('.snd-qd__tier').forEach(function (t) {
        t.classList.toggle('is-active', +t.dataset.tier === active);
      });
    }
    function recomputeAll() { document.querySelectorAll('.snd-qd').forEach(recompute); }

    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('.snd-qd__tier');
      if (card) { var box = card.closest('.snd-qd'); setQty(box, parseInt(card.dataset.q, 10) || 1); recompute(box); return; }
      var qbtn = e.target.closest && e.target.closest('quantity-selector-component button, .quantity-selector button');
      if (qbtn) { requestAnimationFrame(recomputeAll); }
    });
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') recomputeAll(); });
    document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') recomputeAll(); });

    if (document.readyState !== 'loading') recomputeAll();
    else document.addEventListener('DOMContentLoaded', recomputeAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
